import React from "react"
import styled from "@emotion/styled"
import Img from "gatsby-image"

import { breakpoints } from "utils/styles"

const Container = styled.section`
  margin: 90px 0;
  @media (min-width: ${breakpoints.tablet}px) {
    justify-content: ${props => (props.center ? "center" : "space-between")};
    display: flex;
    flex-direction: ${props => (props.reverse ? `row-reverse` : `row`)};
    align-items: center;
  }
`

const SubTitle = styled.h5`
  color: #ff0000;
  margin-bottom: 15px;
`

const Title = styled.h3`
  /*font-family: "Avenir Next";*/
  font-weight: 650;
  line-height: 1.25;
  font-size: 2.1rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: #222;
  @media (max-width: ${breakpoints.mobile}px) {
    margin-top: 0;
    font-size: 1.5rem;
  }
`

const Body = styled.div`
  text-align: center;
  padding: 3.125rem 0.8rem;
  @media (max-width: ${breakpoints.mobile}px) {
    padding: 2rem 0.8rem;
  }
  @media (min-width: ${breakpoints.tablet}px) {
    text-align: left;
    flex-basis: 60%;
    max-width: 40rem;
    padding-left: ${props => (props.reverse ? `5rem` : `0`)};
    padding-right: ${props => (props.reverse ? `0` : `5rem`)};
  }
`

const Copy = styled.div`
  margin-top: 10px;
  font-size: 1.15rem;
  line-height: 1.4;
  color: #162020;
  margin-bottom: 30px;
  p {
    font-family: "Avenir Next";
  }
`

const ButtonContainer = styled.div`
  display: flex;
  @media (max-width: ${breakpoints.mobile}px) {
    align-items: center;
    justify-content: center;
  }
`

const ImgContainer = styled.div`
  margin: 0 auto;
  width: ${props => (props.phoneWidth ? `${props.phoneWidth}%` : `50%`)};
  justify-content: ${props =>
    props.center ? `center` : props.reverse ? `flex-start` : `flex-end`};
  @media (min-width: ${breakpoints.tablet}px) {
    flex-basis: ${props => (props.imageWidth ? `${props.imageWidth}%` : `50%`)};
  }
`

export default ({
  reverse,
  subTitle,
  title,
  subSection,
  actionButtons,
  image,
  imageWidth,
  phoneWidth,
  center,
}) => (
  <Container reverse={reverse} center={center}>
    <Body reverse={reverse}>
      {subTitle && <SubTitle>{subTitle}</SubTitle>}
      <Title>{title}</Title>
      <Copy>{subSection}</Copy>
      <ButtonContainer>{actionButtons}</ButtonContainer>
    </Body>
    <ImgContainer
      reverse={reverse}
      imageWidth={imageWidth}
      phoneWidth={phoneWidth}
    >
      <Img fluid={image} />
    </ImgContainer>
  </Container>
)
